import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const featuresSchema = t.object({
  toggleItem: t.boolean
});
const features = defineMessage({
  type: 'navigation-features',
  payloadSchema: t.object({
    features: featuresSchema
  })
});
const getFeatures = defineMessage({
  type: 'get-navigation-features',
  payloadSchema: t.object({
    source: t.string
  }),
  reply: features
});
export const featuresApi = {
  getFeatures,
  features
};